import { scrollTrigger } from "./_scrollTrigger";

export const imgEffect = () => {
  const imgEffectElements = document.querySelectorAll( '.c-img-effect' );
  imgEffectElements.forEach( function ( item ) {
    scrollTrigger( item, 90 );
  } );
}
